import { forwardRef } from 'react';
import SimpleBar from 'simplebar-react';

import { cn } from 'src/utils/cn';

import { scrollbarClasses } from './classes';

import type { ScrollbarProps } from './types';

// ----------------------------------------------------------------------

export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  ({ children, fillContent, className, style, ...other }, ref) => (
    <SimpleBar
      scrollableNodeProps={{ ref }}
      clickOnTrack={false}
      className={cn(
        scrollbarClasses.root,
        'min-w-0 min-h-0 grow flex flex-col',
        fillContent && '[&_.simplebar-content]:min-h-[1px] [&_.simplebar-content]:flex [&_.simplebar-content]:flex-1 [&_.simplebar-content]:flex-col',
        className
      )}
      style={style}
      {...other}
    >
      {children}
    </SimpleBar>
  )
);
